import { graphql } from '../../graphql/generated';

export const FormRendererFragment = graphql(`
  fragment FormRenderer_Form on Form {
    id
    name
    description
    header
    fields {
      id
      defaultValue
      regex
      help
      label
      required
      type
      placeholder
      name
      options {
        label
        selected
        value
      }
    }
  }
`);
